export default __webpack_public_path__ + "static/media/canon.dce86c2b.svg";